import React from 'react';
import { CallIcon } from './CallUI';

export function ConnectionArtwork() {
  return <div className="discovery-mark" aria-hidden="true">
    <span className="discovery-bubble discovery-bubble-voice"><CallIcon name="mic" /></span>
    <span className="discovery-bubble discovery-bubble-smile"><svg viewBox="0 0 48 48" fill="none"><path d="M15 19v3m18-3v3M15 29c5 6 13 6 18 0" stroke="currentColor" strokeWidth="3" strokeLinecap="round" /></svg></span>
    <span className="discovery-tiny-spark">✦</span>
  </div>;
}

export default function DiscoveryLobby({ loading, connected, onDiscover, onMatches, onWorkshop }) {
  return <section className="discovery-lobby" aria-labelledby="discovery-title">
    <ConnectionArtwork />
    <h2 id="discovery-title">דייט קצר.<br /><span>אולי התחלה גדולה.</span></h2>
    <p className="discovery-tagline">ספיד דייטינג שמתחיל בקול. ממשיך בווידאו. והשאר? אתם מחליטים.</p>
    <div className="discovery-actions">
      <button className="discovery-primary" disabled={loading || !connected} onClick={onDiscover}>
        {loading ? 'מצטרפים…' : !connected ? 'מתחברים…' : "מתחילים ספיד דייט"}<span aria-hidden="true">↗</span>
      </button>
      <button className="discovery-matches" onClick={onMatches}><CallIcon name="message" /> השיחות שלי</button>
      <button className="discovery-matches" onClick={onWorkshop}><span aria-hidden="true">✦</span> סדנת פילטרים</button>
    </div>
    <p className="discovery-footnote">שיחה קצרה, חשיפה הדדית, ואולי דייט אמיתי.</p>
  </section>;
}
